import RoomShareArea from "./RoomShareArea.js";
import ConfirmationArea from "./ConfirmationArea.js";
import RoomArea from "./RoomArea.js";
import UserArea from "./UserArea.js";
import LegalArea from "./LegalArea.js";

import Error from "../utils/Error.js";

import global from "../global.js";

import StateMachine from "statemachine";

const log = global.log.getLogger("f_mtac.ui.StatusArea");
log.setLevel(log.levels.WARN);

let StatusArea = function () {
    log.debug("already disconnected");
    Object.defineProperty(this, "state", {
        get: () => sm.state.name,
        set: () => {}
    });
    Object.defineProperty(this, "space_name", {
        set: (name) => {
            if (name === "") {
                $("#status_area span.room-name").text(global.internationalization.text("global.Without-name"));
            } else {
                $("#status_area span.room-name").text(name);
            }
        },
        get: () => $("#status_area span.room-name").text()
    });
    Object.defineProperty(this, "room", {
        set: (room) => {
            $("#status_area .room-short-id").data("room", room);
            $("#status_area .room-short-id").html(room === null ? "" : `&nbsp;[&thinsp;${room.short_id}&thinsp;]`);
        },
        get: () => $("#status_area span.room-short-id").data("room")
    });
    let sm = new StateMachine({
        name: "connection_state",
        shared_data: {},
        default_state: "disconnected",
        states: {
            disconnected: {
                in: () => {
                    $("#status_area > div.container-fluid").addClass("mtac-status-disconnected");
                    $("meta[name=theme-color]").attr("content", "white");
                },
                out: () => {
                    $("#status_area > div.container-fluid").removeClass("mtac-status-disconnected");
                },
                transit: {
                    connect: {
                        state: "connected",
                        handler: () => {
                            return Promise.resolve(true);
                        }
                    },
                    connection_loss: {
                        state: "connection_lost",
                        handler: () => {
                            return Promise.resolve(true);
                        }
                    }
                },
                schedule: {
                    /*none_timer: {
                        handler: (schedule_data) => {
                            log.info("polling none ", schedule_data);
                        },
                        interval: 500,
                        repeat: Infinity
                    }*/
                }
            },
            connected: {
                in: (state_data) => {
                    log.info("going in state connected ", state_data);
                    $("#status_area > div.container-fluid").addClass("mtac-status-connected");
                    $("meta[name=theme-color]").attr("content", "hsl(79.1, 97.38%, 60%)");
                    if (global.server.network.state === "offline") {
                        sm.transition.connection_lost({});
                    }
                },
                out: (state_data) => {
                    log.info("going out state connected ", state_data);
                    $("#status_area > div.container-fluid").removeClass("mtac-status-connected");
                },
                transit: {
                    disconnect: {
                        state: "disconnected",
                        handler: () => {
                            return this.disconnect();
                        }
                    },
                    connection_loss: {
                        state: "connection_lost",
                        handler: () => {
                            return Promise.resolve(true);
                        }
                    }
                },
                schedule: {
                    none_timer: {
                        handler: (schedule_data) => {
                            log.info("polling none ", schedule_data);
                        },
                        interval: 5000000,
                        repeat: Infinity
                    }
                }
            },
            connection_lost: {
                in: (state_data) => {
                    log.info("going in state connection_lost ", state_data);
                    $("#status_area > div.container-fluid").addClass("mtac-status-connection_lost");
                    $("meta[name=theme-color]").attr("content", "hsl(0, 100%, 50%)");
                },
                out: (state_data) => {
                    log.info("going out state connection_lost ", state_data);
                    $("#status_area > div.container-fluid").removeClass("mtac-status-connection_lost");
                },
                transit: {
                    disconnect: {
                        state: "disconnected",
                        handler: () => {
                            if (global.storage.selected_space.room !== null) {
                                return this.disconnect();
                            } else {
                                return Promise.resolve(true);
                            }
                        }
                    },
                    reconnect: {
                        state: "connected",
                        handler: () => {
                            log.info("Storage.sm reconnect to room", global.storage.selected_space.room);
                            if (global.storage.selected_space.room !== null) return Promise.resolve(true);
                            else return Promise.resolve(false);
                        }
                    }
                },
                schedule: {}
            }
        }
    });

    this.disconnect = async function () {
        if (!global.storage.shared()) {
            log.error("already disconnected");
            return true;
        }
        let space = global.storage.selected_space;
        if (space === null) {
            return false;
        }
        let space_room = space.room;
        await global.storage.unshare();
        try {
            await global.server.mtac_room_disconnect(space_room);
        } catch (error) {
            switch (error.status) {
                case Error.status.access:
                    log.warn("disconnecting from a share after a deregistration");
                    break;
                case Error.status.noent:
                    log.warn("the share doesn't exist on the server");
                    break;
                case Error.status.netdown:
                case Error.status.hostdown:
                    log.warn("disconnecting from a share while offline");
                    break;
                default:
                    throw error;
            }
        }

        // Agnet : remove all msisdn resources
        global.storage.selected_space.delete_agnet_resources_in_all_context();

        return true;
    };

    global.event_bus.subscribe("init", () => {
        global.event_bus.subscribe("network.offline", () => {
            // going offline
            if (global.storage.shared()) {
                sm.transition.connection_lost({});
            } else {
                // keep disconnected state ?
            }
        });

        global.event_bus.subscribe("network.online", () => {
            log.debug("-> on network.online Update StatusArea");
            // back online
            if (global.storage.shared()) {
                sm.transition.connected({});
            } else {
                sm.transition.disconnected({});
            }
        });

        global.event_bus.subscribe("storage.shared", ({room}) => {
            log.debug("received storage.shared", {room});
            this.room = room;
            if (global.server.network.state === "online") {
                sm.transition.connected({});
            } else {
                sm.transition.connection_lost({});
            }
        });

        global.event_bus.subscribe("storage.unshared", () => {
            sm.transition.disconnected({});
            this.room = null;
        });

        global.event_bus.subscribe("storage.space.changed", ({new_space}) => {
            log.debug("received storage.space.changed", {new_space});
            if (new_space === null) {
                this.space_name = "";
                this.room = null;
                return;
            }
            this.space_name = new_space.name;
            new_space.data_commit();
            this.room = new_space.room;
        });

        global.event_bus.subscribe("storage.space.updated", ({space}) => {
            log.debug("received storage.space.updated", {space});
            this.space_name = space.name;
            this.room = space.room;
        });

        global.event_bus.subscribe("internationalization.language.changed", () => {
            this.space_name = global.storage.selected_space.name;
        });

        let profileName = global.configuration.getProfileName(global.configuration.user.level);
        $("#status_area span.user_name").text(`${global.configuration.user.name}`);
        $("#status_area span.user_profile").html(profileName + $("#status_area span.user_profile").html());

        if (global.storage.selected_space !== null) {
            this.space_name = global.storage.selected_space.name;
        }

        $("body").on("click", "#status_area button.user", () => {
            let initialLevel = global.configuration.user.level;
            let initialPofileName = global.configuration.getProfileName(initialLevel);
            UserArea.interact({enable_cancel: true}).then((user) => {
                $("#status_area span.user_name").text(`${user.name}`);
                let newProfileName = global.configuration.getProfileName(user.level);
                let new_html = $("#status_area span.user_profile").html().replace(initialPofileName, newProfileName);
                $("#status_area span.user_profile").html(new_html);
                if (user.level !== initialLevel) {
                    global.event_bus.publish("user.level.changed", {level: user.level});
                }
            });
        });

        $("body").on("click", "#status_area button.room", async () => {
            if (global.storage.shared()) {
                let confirmation = await ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1: global.internationalization.text("collaboration.Stop-ongoing-sharing"),
                    tip2: ""
                });
                if (!confirmation) {
                    return;
                }
                sm.transition.disconnected({});
            }
            RoomArea.interact();
        });

        $("body").on("click", "#status_area button.le-bidon", async () => {
            if (global.storage.selected_space.room !== null) {
                let confirmation = await ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1: global.internationalization.text("collaboration.Stop-ongoing-sharing"),
                    tip2: ""
                });
                if (!confirmation) {
                    return;
                }
                sm.transition.disconnected({});
            } else {
                RoomShareArea.interact();
            }
        });

        $("body").on("click", "#status_area button.info", async () => {
            LegalArea.interact();
        });

        this.refresh_logo();

        global.event_bus.subscribe("geolocation.state", ({state}) => {
            switch (state) {
                case "disabled":
                    $("#status_area button.gps i").attr("class", "f_mtac-icon-gps_active_no");
                    break;
                case "errored":
                    $("#status_area button.gps i").attr("class", "f_mtac-icon-gps_active_no");
                    break;
                case "enabled":
                    $("#status_area button.gps i").attr("class", "f_mtac-icon-gps_active_yes");
                    break;
            }
        });
    });

    this.refresh_logo = async function () {
        log.debug(`StatusArea.refresh_logo uri = ${global.commissioning.uri.logo}`);
        await fetch(global.commissioning.uri.logo, {cache: "reload"})
            .then((logo) => logo.text())
            .then((logo_text) => new DOMParser().parseFromString(logo_text, "application/xml"))
            .then((logo) => {
                log.debug("StatusArea.refresh_logo update DOM", {logo});
                $("#status_area .logo").empty(); // remove if any
                $("#status_area .logo").html(); // remove if any
                $("#status_area .logo")[0].append(logo.documentElement);
            });
    };

};

export default new StatusArea();
